import type { PromptSection } from './systemPromptEditorUtils';
import { SYSTEM_PROMPT_MODAL_CONTENT_HEIGHT_PX } from './systemPromptEditorUtils';

const SECTIONS_LABEL = 'Sections';

export type PromptSectionSidebarProps = Readonly<{
  sections: PromptSection[];
  activeSectionId: string | null;
  onSelect: (section: PromptSection) => void;
}>;

export function PromptSectionSidebar({ sections, activeSectionId, onSelect }: PromptSectionSidebarProps) {
  return (
    <nav
      className="w-48 shrink-0 border-r border-divider pr-3 overflow-y-auto"
      style={{ maxHeight: SYSTEM_PROMPT_MODAL_CONTENT_HEIGHT_PX }}
    >
      <p className="text-xs font-semibold text-default-500 uppercase mb-2">{SECTIONS_LABEL}</p>
      <ul className="flex flex-col gap-0.5">
        {sections.map((section) => (
          <li key={section.id}>
            <button
              type="button"
              className={`w-full text-left text-sm py-1.5 px-2 rounded-md transition-colors truncate ${
                activeSectionId === section.id
                  ? 'bg-primary/10 text-white font-medium'
                  : 'text-default-700 hover:bg-default-100'
              }`}
              style={{ paddingLeft: `${(section.level - 1) * 12 + 8}px` }}
              title={section.title}
              onClick={() => onSelect(section)}
            >
              {section.title}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
